import { SalesLocation } from '../types/customers';
import fulfill from '../fulfill';
import { CORE_API_HOSTNAME } from '../env';

const fetchLocationsReq = async (accountId: string, params: URLSearchParams): Promise<SalesLocation[]> => {
    return fulfill.get({
        accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${accountId}/locations/?${params.toString()}`,
        handlers: {
            200: (locations: SalesLocation[]) => locations,
            404: () => [],
        },
    });
};

export const recursivelyFetchLocations = async (
    accountId: string,
    params: URLSearchParams,
    locations: SalesLocation[]
): Promise<SalesLocation[]> => {
    const nextParams = new URLSearchParams(params);
    nextParams.delete('starting_after');
    if (locations.length > 0 && locations[locations.length - 1].location_id) {
        nextParams.append('starting_after', locations[locations.length - 1].location_id || '');
    }
    const fetchedLocations = await fetchLocationsReq(accountId, nextParams);
    const nextLocations = [...locations, ...fetchedLocations];
    if (fetchedLocations.length.toString() === params.get('limit')) {
        return recursivelyFetchLocations(accountId, params, nextLocations);
    }
    return nextLocations;
};
